import { Component, OnInit, OnDestroy } from '@angular/core';
import { PWAService, PWAInstallationState } from '../../services/pwa-service';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-pwa-install-prompt',
  templateUrl: './pwa-install-prompt.component.html',
  styleUrls: ['./pwa-install-prompt.component.scss']
})
export class PWAInstallPromptComponent implements OnInit, OnDestroy {
  public showPrompt = false;
  public isInstalling = false;
  public installationState: PWAInstallationState | null = null;
  
  private destroy$ = new Subject<void>();

  constructor(
    private pwaService: PWAService,
    private translateService: TranslateService
  ) {}

  ngOnInit(): void {
    this.pwaService.installationState$
      .pipe(takeUntil(this.destroy$))
      .subscribe(state => {
        this.installationState = state;
        this.showPrompt = this.pwaService.shouldShowInstallPrompt();
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  public async installApp(): Promise<void> {
    if (this.isInstalling) return;
    
    this.isInstalling = true;
    try {
      const success = await this.pwaService.installPWA();
      if (success) {
        this.showPrompt = false;
      }
    } finally {
      this.isInstalling = false;
    }
  }

  public dismissPrompt(): void {
    this.pwaService.dismissInstallPrompt();
    this.showPrompt = false;
  }

  public get isIOS(): boolean {
    return this.installationState?.isIOS || false;
  }

  public get canInstallDirectly(): boolean {
    return this.installationState?.canInstall || false;
  }

  public getIOSInstructions(): string[] {
    return this.pwaService.getIOSInstallInstructions();
  }
}
